import { ReactNode, useEffect, useState } from "react";
import { Layout, Menu, Avatar, Typography, Dropdown } from "antd";
import {
    DashboardOutlined,
    CarOutlined,
    UserOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    RobotOutlined,
} from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useNavigate, useLocation } from "react-router-dom";
import { storage } from "../utils/storage";
import Images from "../assets/image/index";

const { Sider } = Layout;
const { Text } = Typography;

const SIDEBAR_BG = "#1a1a2e";
const ACCENT = "#6366f1";

type TravellerLayoutProps = {
    children: ReactNode;
};

const menuItems = [
    { key: "/my-dashboard", icon: <DashboardOutlined />, label: "Dashboard" },
    { key: "/my-trips", icon: <CarOutlined />, label: "My Trips" },
    { key: "/my-assistant", icon: <RobotOutlined />, label: "AI Assistant" },
    { key: "/my-profile", icon: <UserOutlined />, label: "My Profile" },
];

const TravellerLayout = ({ children }: TravellerLayoutProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const [userName, setUserName] = useState("Traveller");

    useEffect(() => {
        const stored = storage.getEmailId();
        if (stored) setUserName(stored.split("@")[0]);
    }, []);

    const handleLogout = () => {
        storage.clearToken();
        storage.clearRefreshToken();
        storage.clearUserRoleId();
        window.localStorage.clear();
        navigate("/");
    };

    const userMenuItems = [
        {
            key: "logout",
            icon: <LogoutOutlined />,
            label: "Sign Out",
            onClick: handleLogout,
        },
    ];

    return (
        <Layout style={{ minHeight: "100vh" }}>
            {/* Sidebar */}
            <Sider
                collapsible
                collapsed={collapsed}
                onCollapse={setCollapsed}
                width={220}
                collapsedWidth={64}
                trigger={null}
                style={{ backgroundColor: SIDEBAR_BG, position: "fixed", height: "100vh", left: 0, top: 0, zIndex: 100 }}
            >
                {/* Logo */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: collapsed ? "16px 0" : "16px",
                        justifyContent: collapsed ? "center" : "flex-start",
                        borderBottom: "1px solid rgba(255,255,255,0.08)",
                        height: 64,
                    }}
                >
                    <img
                        src={Images.triplogo}
                        alt="logo"
                        style={{ width: collapsed ? 32 : 110, transition: "width 0.2s", objectFit: "contain" }}
                    />
                </div>

                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    onClick={(e) => navigate(e.key)}
                    style={{ backgroundColor: SIDEBAR_BG, marginTop: 8 }}
                    items={menuItems}
                />

                {/* Collapse toggle */}
                <div
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                        position: "absolute",
                        bottom: 72,
                        left: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: collapsed ? "center" : "flex-end",
                        padding: "0 16px",
                        cursor: "pointer",
                        color: "rgba(255,255,255,0.45)",
                    }}
                >
                    {collapsed ? <MenuUnfoldOutlined style={{ fontSize: 16 }} /> : <MenuFoldOutlined style={{ fontSize: 16 }} />}
                </div>

                {/* User info at bottom */}
                {!collapsed && (
                    <div
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: "12px 16px",
                            borderTop: "1px solid rgba(255,255,255,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <Dropdown menu={{ items: userMenuItems }} trigger={["click"]} placement="topLeft">
                            <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
                                <Avatar size={32} style={{ backgroundColor: ACCENT }}>
                                    {userName.charAt(0).toUpperCase()}
                                </Avatar>
                                <div style={{ lineHeight: "1.2" }}>
                                    <Text style={{ color: "#fff", fontSize: 13, display: "block", fontWeight: 600 }}>
                                        {userName}
                                    </Text>
                                    <Text style={{ color: "rgba(255,255,255,0.45)", fontSize: 11 }}>Traveller</Text>
                                </div>
                            </div>
                        </Dropdown>
                    </div>
                )}
            </Sider>

            {/* Main content */}
            <Layout style={{ marginLeft: collapsed ? 64 : 220, transition: "margin-left 0.2s" }}>
                <Content style={{ backgroundColor: "#f5f6fa", minHeight: "100vh", padding: 28 }}>
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
};

export default TravellerLayout;
